const buildInfo = {buildnumber:'12187',commit:'0dbc9589c8c8be8dc2e8d7be77ef4fb645447f32',tag:'2.33.50'};export default buildInfo
